(ns common.schema.entities.meeting
  (:require [common.schema.option-filters :as option-filters]
            [common.schema.entities.related-entities :as related-entities]
            [common.schema.entities.activity :as activity]))

(defonce import-fixed-fields [:note-meeting/message])

(def new-meeting
  (concat [[:note-meeting/message {
                                   :field/data-type          :data.type/text-richtext
                                   :field/default-authorization      {:access/read  :role/guest-buy-side
                                                              :access/write :role/guest-buy-side}
                                   :field/default-visibility {:editor :editor.type/none
                                                              :grid   :editor.type/none
                                                              :filter :filter.type/text
                                                              :field-visibility :in-use-disabled}
                                   :field/translations       {:en "Message"}}]
           [:note-meeting/participants {
                                        :field/data-type          :data.type/ref-multi
                                        :field/default-authorization      {:access/read  :role/guest-buy-side
                                                                   :access/write :role/guest-buy-side}
                                        :field/default-visibility {:editor :editor.type/multi-select
                                                                   :grid   :editor.type/multi-select
                                                                   :filter :filter.type/select
                                                                   :field-visibility :in-use-disabled}
                                        :field/entity-types       [:entity.type/account]
                                        :value-type               :entity
                                        :field/translations       {:en "Participants"}
                                        :field/option-filter-fn   option-filters/active-users
                                        :field/os-filter-terms-fn    (fn [{:keys [] :as args}]
                                                                       {"extras.active-user" true})
                                        }]
           [:note-meeting/timestamp {
                                     :field/data-type          :data.type/date
                                     :field/default-authorization      {:access/read  :role/guest-buy-side
                                                                :access/write :role/guest-buy-side}
                                     :field/default-visibility {:editor :editor.type/date
                                                                :grid   :editor.type/date
                                                                :filter :filter.type/date
                                                                :field-visibility :in-use-disabled}
                                     :field/translations       {:en "Date"}}]]
          activity/new-activity
          related-entities/related-entities))
